/**
 * The four-layer background system from design.xml: base radial gradient, noise, animated
 * blurred light pools and a faint grid. Purely decorative, so hidden from assistive tech.
 * Blobs are clipped by `overflow-hidden` so they never cause horizontal scroll.
 */
export function AmbientBackground() {
  return (
    <div aria-hidden="true" className="pointer-events-none fixed inset-0 -z-10 overflow-hidden">
      <div className="bg-canvas absolute inset-0" />
      <div className="bg-noise absolute inset-0 opacity-[0.015]" />

      <div className="animate-float absolute -top-[40rem] left-1/2 h-[87.5rem] w-[56rem] -translate-x-1/2 rounded-full bg-accent/25 blur-[150px]" />
      <div className="animate-float-slow absolute top-1/4 -left-64 h-[50rem] w-[37.5rem] rounded-full bg-blob-violet blur-[120px]" />
      <div className="animate-float absolute top-1/3 -right-48 h-[44rem] w-[31rem] rounded-full bg-blob-indigo blur-[100px] [animation-delay:-4s]" />
      <div className="animate-pulse-glow absolute -bottom-64 left-1/3 h-[32rem] w-[48rem] rounded-full bg-accent/10 blur-[120px]" />

      <div className="bg-grid absolute inset-0 opacity-[0.02]" />
    </div>
  );
}
